@if (routerLink() !== null && routerLink() !== undefined && !disabled()) {
  <a
    class="nav-trigger"
    [class.is-active]="active()"
    [class.is-open]="open()"
    [class.nav-trigger-ai-compact]="variant() === 'ai-compact'"
    [routerLink]="routerLink()"
    [queryParams]="queryParams() || null"
    [attr.aria-label]="ariaLabel() || null"
    [attr.aria-current]="ariaCurrent() ?? null"
    [attr.aria-pressed]="ariaPressed() ?? null"
    [attr.aria-haspopup]="ariaHaspopup() || null"
    [attr.aria-expanded]="ariaExpanded() ?? null"
    (click)="onClick($event)">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
} @else {
  <button
    type="button"
    class="nav-trigger"
    [class.is-active]="active()"
    [class.is-open]="open()"
    [class.nav-trigger-ai-compact]="variant() === 'ai-compact'"
    [disabled]="disabled()"
    [attr.aria-label]="ariaLabel() || null"
    [attr.aria-current]="ariaCurrent() ?? null"
    [attr.aria-pressed]="ariaPressed() ?? null"
    [attr.aria-haspopup]="ariaHaspopup() || null"
    [attr.aria-expanded]="ariaExpanded() ?? null"
    (click)="onClick($event)">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </button>
}

<ng-template #content><ng-content></ng-content></ng-template>
